export const CONFIG_REQUEST = "CONFIG_REQUEST";
export const SET_CURRENT_COMPANY = "SET_CURRENT_COMPANY";
export const SET_USER_LIST = "SET_USER_LIST";
export const SET_COMPANY_LIST = "SET_COMPANY_LIST";
